import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Col, Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputText from '../../commons/form/InputText'
import DocumentTypeModalPage from '../../../containers/masters/DocumentType/DocumentTypeModalPage'
import InputSelect from '../../commons/form/InputSelect'
import MapSectionsMasters from '../../../util/map-sections-masters'

class DocumentTypeMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        entityTypeId: null,
        text: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchDocumentTypeEntities()
    this.props.actions.fetchDocumentTypeList()
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchDocumentTypeList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchDocumentTypeList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleTextChange (text) {
    if (this.state.filter.text !== text) {
      this.setState({ filter: { ...this.state.filter, text } })
    }
  }

  handleEntityChange (entityTypeId) {
    if (this.state.filter.entityTypeId !== entityTypeId) {
      this.setState({ filter: { ...this.state.filter, entityTypeId } })
    }
  }

  searchDocumentType () {
    this.props.actions.fetchDocumentTypeList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  resetFilters () {
    this.setState({
      filter: {
        entityTypeId: null,
        text: null
      }
    }, () => { this.searchDocumentType() })
  }

  render () {
    const {
      t, documentTypeList, pagesCount, documentTypesCount, filter,
      combos: { documentTypeEntities },
      filter: { page },
      actions: { openDocumentTypeModal, fetchDocumentTypeList, deleteDocumentType }
    } = this.props
    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'documentTypeMasterPage' })
    const tKey = 'MASTERS.DOCUMENT_TYPE_MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const hasFilters = (this.state.filter.entityTypeId || this.state.filter.text)
    return (
      <div id='documentTypeMaster' className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => openDocumentTypeModal(null)}>
              <i className='iDocIcon-add-plus'></i> {t(`${tKey}ADD`)} {t(`${secMapMasters.title}`)}
            </Button>
          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.entityTypeId"
                controlLabel={t(`${tKey}ENTITY_TYPE`)}
                placeholder={t(`${tKey}ENTITY_TYPE`)}
                valueKey="id"
                labelKey="value"
                options={documentTypeEntities}
                onInputChange={(value) => this.handleEntityChange(value)}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.text"
                controlLabel={t(`${tKey}TEXT`)}
                placeholder={t(`${tKey}TEXT`)}
                valueKey="id"
                labelKey="value"
                maxLength={50}
                onInputChange={(value) => this.handleTextChange(value)}
              />
              <div className="search-form-actions flexInLine al-R">
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.searchDocumentType()}>
                  <i className="iDocIcon-search"/>
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer' + (this.state.maxiTable ? ' maxiTable' : '')}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              <Table className="editable-table" hover responsive>
                <thead>
                  <tr>
                    <th onClick={() => { this.changeOrder('documentTypeId') }}>
                      {t(`${tKey}ID`)}
                      <i className={this.getSortIcon('documentTypeId')} />
                    </th>
                    <th onClick={() => { this.changeOrder('documentTypeEntityId') }}>
                      {t(`${tKey}ENTITY_TYPE`)}
                      <i className={this.getSortIcon('documentTypeEntityId')} />
                    </th>
                    <th onClick={() => { this.changeOrder('localeName') }}>
                      {t(`${tKey}NAME`)}
                      <i className={this.getSortIcon('localeName')} />
                    </th>
                    <th onClick={() => { this.changeOrder('localeDescription') }}>
                      {t(`${tKey}DESCRIPTION`)}
                      <i className={this.getSortIcon('localeDescription')} />
                    </th>
                    <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                  </tr>
                </thead>
                <tbody>
                  {documentTypeList && documentTypeList.map((documentType, idx) => {
                    return (
                      <tr key={idx} className={documentType.isDeleted ? 'is-deleted' : ''}>
                        <td>{documentType.id}</td>
                        <td>{documentTypeEntities && documentTypeEntities.find(x => x.id === documentType.documentTypeEntityId) && documentTypeEntities.find(x => x.id === documentType.documentTypeEntityId).value}</td>
                        <td>{documentType.documentTypeLocales && documentType.documentTypeLocales.length > 0 ? documentType.documentTypeLocales.find(lang => (lang.languageId ? lang.languageId : '') === this.props.languageSelected)?.name : ''}</td>
                        <td>{documentType.documentTypeLocales && documentType.documentTypeLocales.length > 0 ? documentType.documentTypeLocales.find(lang => (lang.languageId ? lang.languageId : '') === this.props.languageSelected)?.description : ''}</td>
                        <td className='actions'>
                          {!documentType.isDeleted && (
                            <div>
                              <OverlayTrigger placement="left" overlay={editTooltip}>
                                <a className='_Btn accept stk o-icn ' onClick={() => openDocumentTypeModal(documentType)}>
                                  <i className="iDocIcon-edit" />
                                </a>
                              </OverlayTrigger>
                              <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                <a className='_Btn cancel stk o-icn ' onClick={() => deleteDocumentType(documentType.id)}>
                                  <i className="iDocIcon-delete-forever" />
                                </a>
                              </OverlayTrigger>
                            </div>
                          )}
                        </td>
                      </tr>
                    )
                  })}

                </tbody>
              </Table>
              {(documentTypeList === null || documentTypeList === undefined || documentTypeList.length === 0) &&
            <p className="no_results" >{t(`${tKey}RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_sales"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={documentTypesCount}
                    onSelectAction={(value) => fetchDocumentTypeList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>

        <Col sm={12} className="col-row  section-users-body">

        </Col>
        <DocumentTypeModalPage/>
      </div>
    )
  }
}

export default reduxForm({
  form: 'listDocumentType'
})(DocumentTypeMaster)
